import React, { useEffect, useRef } from "react";

export function FlipClock({ clockFace = "DailyCounter", className = "", weddingDate = null, weddingTimezone = null, ...props }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    // If the global FlipClock (and jQuery it depends on) is loaded in index.html, use it.
    if (typeof window !== "undefined" && window.FlipClock) {
      // Instantiate the FlipClock on the container element.
      // The second arg (0) starts it at zero; options include clockFace and optional wedding configuration.
      const instance = window.FlipClock(el, 0, { clockFace, weddingDate, weddingTimezone });

      return () => {
        // Try to stop the clock if API exists, and clean up DOM
        try {
          if (instance && typeof instance.stop === "function") {
            instance.stop();
          }
        } catch (e) {
          // ignore cleanup errors
        }
        // Remove generated child nodes to avoid duplicates on remount
        el.innerHTML = "";
      };
    } else {
      // Fallback messaging if FlipClock isn't available
      el.textContent = "FlipClock not loaded";
    }
  }, [clockFace, weddingDate, weddingTimezone]);

  return <div ref={ref} className={`flipclock-wrapper ${className}`} {...props} />;
}
